import React from "react";
import { useTranslation } from "react-i18next";

// `label` holds a key name, not copy -- resolved through t() at render so a
// language switch re-reads it instead of freezing the English at module load.
const policies = [
  { label: "policies.terms", path: "/policies/terms" },
  { label: "policies.privacy", path: "/policies/privacy" },
  { label: "policies.returns", path: "/policies/returns" },
  { label: "policies.shipping", path: "/policies/shipping" },
];

const Policies = ({ onNav }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="text-[10px] font-[500] tracking-[0.1em] uppercase text-[#707078] pt-[12px] px-[16px] pb-[6px]">
        {t("policies.heading")}
      </div>
      <div className="flex flex-wrap gap-x-[8px] gap-y-[7px] pt-[6px] px-[16px] pb-[4px]">
        {policies.map((p) => (
          <span
            key={p.label}
            onClick={() => onNav?.(p.path)}
            className="text-[11px] text-[#545454] underline underline-offset-2 cursor-pointer"
          >
            {t(p.label)}
          </span>
        ))}
      </div>
    </>
  );
};
export default Policies;
